import { Spinner } from "@chakra-ui/react"

export const MenuItemSpinner = ({ ml, mr }) => {
    return <Spinner size="sm" ml={ml || 0.5} mr={mr || 0.5} />
}